.yes-no-select__container {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
}

.yes-no-select__container .yes-no-select__title {
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  text-align: left;
}

.yes-no-select__container .yes-no-select__description {
  color: #555768;

  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;

  white-space: pre-wrap;
}

.yes-no-select__choices-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;

  gap: 24px;
}

.yes-no-select__container .yes-no-select__label {
  cursor: pointer;

  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  gap: 8px;

  font-weight: 400;
  font-size: 16px;
  line-height: 24px;

  padding: 4px 8px;
  border: 1px solid transparent;
}

.yes-no-select__danger .yes-no-select__label {
  color: var(--color-danger-medium);
}

.yes-no-select__container .yes-no-select__label:hover {
  border-color: gray;
  border-radius: 8px;
}

.yes-no-select__container .yes-no-select__label-disabled {
  cursor: not-allowed;
}

.yes-no-select__container .yes-no-select__selected {
  fill: #22BDFF;
}